import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import PasswordChangeBox from "../../components/PasswordChangeBox";
import {MyContext} from "../../context/myContext";
import {useDispatch, useSelector} from "react-redux";
import {handleShowTopMenuPasswordForm, postTopMenuPasswordForm, selectShowTopMenuPasswordForm} from "./topMenuSlice";

const data = [
    {id: 'icon1', name: 'currentPass', label: 'رمز عبور فعلی'},
    {id: 'icon2', name: 'newPass', label: 'رمز عبور جدید'},
    {id: 'icon3', name: 'repeatNewPass', label: 'تکرار رمز عبور'},
]

const TopMenu = () => {
    const initialPasswords = {currentPass: '', newPass: '', repeatNewPass: ''}
    const initialShowPass = {icon1: false, icon2: false, icon3: false}
    const [showDropDown, setShowDropDown] = useState(false)
    const navigate =useNavigate();
    const dispatch = useDispatch()
    const showTopMenuPasswordForm = useSelector(selectShowTopMenuPasswordForm)

    let ref = useRef(null)
    const handleShowDropdown = () => {
        setShowDropDown(!showDropDown)
    }
    const handleShowPasswordForm = () => {
        dispatch(handleShowTopMenuPasswordForm(!showTopMenuPasswordForm))
    }
    const handleClosePopup = () => {
        if(showTopMenuPasswordForm === true){
            dispatch(handleShowTopMenuPasswordForm(false))
        }
    }
    const handleExit = () => {
        navigate('/')
    }
    const handleSubmit = (currentPass, newPass) => {
        const data = {
            current_password: currentPass,
            new_password: newPass
        }
        dispatch(postTopMenuPasswordForm({data, dispatch}))
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if(ref.current && !ref.current.contains(event.target)){
                setShowDropDown(false)
            }
        }
        document.addEventListener('click', handleClickOutside, true)
        return() => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    }, [])

    return(
        <div className='top-menu'>
            <div className='user' onClick={handleShowDropdown}>
                <span ref={ref}><span className="username">{localStorage.getItem('userName')}</span><i className="fa fa-solid fa-user user-icon"></i></span>
                <div className={`${showDropDown && 'show'} dropdown-user`}>
                    <p onClick={handleShowPasswordForm}>تغییر رمز عبور</p>
                    <p onClick={handleExit}>خروج</p>
                </div>
            </div>
            <div className='caption'><span className='top-menu-title'>سامانه مدیریت آبرسانی عشایر</span><img alt='office-icon' className='icon' src='/Untitled.jpg' /></div>
            <div className={`${showTopMenuPasswordForm && 'show-dark-background'} dark-background`} onClick={handleClosePopup}></div>
            <MyContext.Provider value={{handleShowForm: handleShowPasswordForm, showTopMenuPasswordForm, data, initialPasswords, initialShowPass, handleSubmit, formTitle: 'تغییر رمزعبور'}}>
                <PasswordChangeBox />
            </MyContext.Provider>
        </div>
    )
}

export default TopMenu